import { TypedStorage } from '@/utils/TypedStorage';

const legacyGetToken = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return TypedStorage.get('viewer_jwt') ?? undefined;
};

/**
 * Logs out a BYO anonymous participant by dropping the legacy `viewer_jwt`. BYO
 * tokens only live on that localStorage path (no Kinde, no refresh), so clearing
 * it fully ends the anon session.
 */
export const clearAnonymousParticipantToken = () => {
  TypedStorage.remove('viewer_jwt');
};

/**
 * Global auth configuration mutated at runtime by `AuthProvider` / `SetUpKinde`
 * once the Kinde browser client is ready, and by `ParentAuthTokenProvider` when
 * embedded. Default is the legacy localStorage path (no refresh available);
 * `AuthProvider` swaps in Kinde-backed implementations that auto-refresh.
 */
export const AUTH_CONFIG: {
  getToken: () => string | undefined | null;
  /**
   * Obtains a fresh token for the urql auth exchange: Kinde in a top-level window, the embedding app
   * (`ParentAuthTokenProvider`) in an iframe. Undefined where nothing can mint one; `refreshAuth` is then a no-op.
   */
  refreshToken?: () => Promise<string | undefined>;
} = {
  getToken: () => {
    return legacyGetToken();
  },
};
